<template>
    <div>
        {{ test }} <br /><br />

        <!-- test buttons -->
        <div style="padding-bottom: 15px;;">
            <b-button variant="outline-primary" style="margin-right: 10px;" @click="GetAllAssets()">GetAllAssets</b-button> 
            <b-button v-b-modal.modal-1 variant="outline-primary" style="margin-right: 10px;">CreateAsset</b-button>
            <b-button v-b-modal.modal-3 variant="outline-primary" style="margin-right: 10px;">View Template</b-button>
        </div>

        <!-- test table -->
        <div>Contracts {{ assetCount }}</div>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Owner</th>
                    <th scope="col">State</th>
                    <!-- <th scope="col">TempData</th> -->
                    <th scope="col">TimeStamp</th>
                    <th scope="col">User</th>
                </tr>
            </thead>
            <tbody>
                <!-- <tr v-for="block in blockchain" v-bind:key="block.ID" class="hover-table" v-b-modal="'contract-detals-modal'" @click="openBlock(block)"> -->
                <tr v-for="block in blockchain" v-bind:key="block.ID" class="hover-table" v-b-modal="'modal-2'" @click="openBlock(block)">
                    <td> {{ block.ID }} </td>
                    <td> {{ block.Owner }} </td>
                    <td> {{ block.State }} </td>
                    <!-- <td> {{ block.TempData }} </td> -->
                    <td> {{ block.TimeStamp }} </td>
                    <td> {{ block.User }} </td>
                </tr>
            </tbody>
        </table>

        <!-- CreateAsset Modal -->
        <b-modal id="modal-1" title="BootstrapVue" @ok="CreateAsset()">
            <b-form-group id="input-group-1" label="Contract Name:" label-for="input-1">
                    <b-form-input
                        id="input-1"
                        v-model="contractName"
                        placeholder="Enter name for contract"
                    ></b-form-input>
                </b-form-group>
        </b-modal>

        <!-- UpdateAsset Modal -->
        <b-modal id="modal-2" sixe="lg" title="BootstrapVue" @ok="UpdateAsset()">
            <!-- form -->
            <div>
                <b-form-group id="input-group-1" label="ID:" label-for="input-1">
                    <b-form-input
                        id="input-1"
                        v-model="selectedBlock.ID"
                        disabled
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="Owner:" label-for="input-2">
                    <b-form-input
                        id="input-2"
                        v-model="selectedBlock.Owner"
                    ></b-form-input>
                </b-form-group>            
                <b-form-group id="input-group-1" label="State:" label-for="input-2">
                    <b-form-input
                        id="input-2"
                        v-model="selectedBlock.State"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="TempData:" label-for="input-1">
                    <b-form-input
                        id="input-1"
                        v-model="selectedBlock.TempData"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="TimeStamp:" label-for="input-1">
                    <b-form-input
                        id="input-1"
                        v-model="selectedBlock.TimeStamp"
                        disabled
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="User:" label-for="input-1">
                    <b-form-input
                        id="input-1"
                        v-model="selectedBlock.User"
                    ></b-form-input>
                </b-form-group>
            </div>
            
            <!-- table -->
            <div>Contract ID {{ selectedBlock.ID }}</div>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Owner</th>
                        <th scope="col">State</th>
                        <!-- <th scope="col">TempData</th> -->
                        <th scope="col">TimeStamp</th>
                        <th scope="col">User</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="block in contractHistory" v-bind:key="block.ID" class="hover-table" v-b-modal="'modal-2'">
                        <td> {{ block.ID }} </td>
                        <td> {{ block.Owner }} </td>
                        <td> {{ block.State }} </td>
                        <!-- <td> {{ block.TempData }} </td> -->
                        <td> {{ block.TimeStamp }} </td>
                        <td> {{ block.User }} </td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
        
        <!-- contract details modal (milestsones) -->
        <b-modal id="contract-detals-modal" ref="contractDetailsModal" size="lg" :title="selectedBlock.name" ok-only ok-variant="secondary" button-size="sm" ok-title="Close" scrollable>

            <!-- contract details -->
            <div id="blockchain-modal" style="height: calc(100vh - 230px); margin-top: -16px;">

                <!-- tabs -->
                <div style="margin-top: 20px;">
                    <b-tabs content-class="mt-3">

                        <!-- Summary tab -->
                        <b-tab title="Summary">

                            <!-- Summary for Huon 2023 - Template -->
                            <div v-if="template.TempData.contract.name != 'Huon 2023 - Template'" style="padding-top: 16px;">
                                <strong>Section under development...</strong>
                                <div style="max-width: 500px; margin-top: 10px;"><b-progress value="100" variant="info" :striped="true" animated></b-progress></div>
                            </div>
                            <div v-else style="padding-top: 16px;">

                                <!-- left side -->
                                <div style="float: left; width: 50%; padding-left: 35px;">
                                    <div style="width: 300px; text-align: center;">
                                        <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); text-align: center;">
                                            <img style="width: 300px;" src="https://lc-token-testing.s3.ap-southeast-2.amazonaws.com/ID-0011.png" />
                                            <div style="padding: 15px;">
                                                {{ selectedBlock.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- right side -->
                                <div class="nft-summary" style="float: left; width: 50%;">

                                    <!-- NFT Details -->
                                    <div v-b-toggle.nft-section class="m-1 section-label" @click="summary_sections.nft_expanded = !summary_sections.nft_expanded">
                                        <div class="section-icon">
                                            <img style="height: 25px;" src="../../assets/images/nft_logo.png"/>
                                        </div>
                                        <div class="section-label-details">
                                            <span><b>NFT</b></span>
                                            <br />
                                            <span>{{ selectedBlock.name }}</span>
                                        </div>
                                        <span class="section-chevron">
                                            <i class="fa-solid" :class="summary_sections.nft_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </span>
                                        <b-collapse id="nft-section">
                                            <div  class="collapse-section-container" v-on:click.stop>
                                                <table class="summary-section-table">
                                                    <!-- <tr>
                                                        <td style="width: 90px;"><b>Name</b></td>
                                                        <td>{{ selectedBlock.name }}</td>
                                                    </tr>                                           -->
                                                    <tr>
                                                        <td style="width: 90px;"><b>Type</b></td>
                                                        <td>Stacked NFT</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Fish ID</b></td>
                                                        <td><a href="#" v-b-modal.master-nft-modal>5584231 (Master NFT)</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 90px;"><b>Transaction</b></td>
                                                        <td><a target="_blank" href="https://goerli.etherscan.io/tx/0xe417291dbeb45104cbd2ffe5d6fc735613c7c8b9629fab9e5b5023db5ee96408">0xe417291dbeb45104c...</a></td>
                                                    </tr>                                                                                                                                                                                                    
                                                    <tr>
                                                        <td style="width: 90px;"><b>Description</b></td>
                                                        <td>Package ID</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>QR Code</b></td>
                                                        <td><a href="#">click to view</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Owned By</b></td>
                                                        <td><a href="#">lifechain</a></td>
                                                    </tr>                                                                  
                                                </table>
                                            </div>
                                        </b-collapse>
                                    </div>                                                

                                    <!-- Status Details  -->
                                    <div v-b-toggle.contract-section class="m-1 section-label" @click="summary_sections.contract_expanded = !summary_sections.contract_expanded">
                                        <div class="section-icon"><i class="fa-solid fa-clipboard-check"></i></div>
                                        <div class="section-label-details">
                                            <span><b>Status</b></span>
                                            <br />
                                            <!-- <span>4.1 Liquid Nitrogen Dewar, -196°C</span> -->
                                            <b-badge pill variant="primary">{{ selectedBlock.nextState }} {{ selectedBlock.nextStateName }}</b-badge>
                                        </div>
                                        <span class="section-chevron">
                                            <i class="fa-solid" :class="summary_sections.contract_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </span>
                                        <b-collapse id="contract-section">
                                            <div  class="collapse-section-container" v-on:click.stop>
                                                <table class="summary-section-table">
                                                    <tr>
                                                        <td style="width: 90px;"><b>Contract</b></td>
                                                        <td>{{ selectedBlock.name }}</td>
                                                    </tr>                                                        
                                                    <tr>
                                                        <td style="width: 90px;"><b>Template</b></td>
                                                        <td>{{ template.TempData.contract.name }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 90px;"><b>Created</b></td>
                                                        <td>{{ selectedBlock.TimeStamp }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 90px;"><b>Creator</b></td>
                                                        <td>{{ selectedBlock.User }}</td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td style="width: 90px;"><b>State</b></td>
                                                        <td><b-badge pill variant="primary">{{selectedBlock.nextState }} {{selectedBlock.nextStateName }}</b-badge></td>
                                                    </tr> -->
                                                </table>
                                            </div>
                                        </b-collapse>
                                    </div>                                        

                                    <!-- Location Details  -->
                                    <div v-b-toggle.location-section class="m-1 section-label" style="cursor: initial;" @click="summary_sections.location_expanded = !summary_sections.location_expanded">
                                        <div class="section-icon"><i class="fa-solid fa-location-dot"></i></div>
                                        <div class="section-label-details">
                                            <span><b>Location</b></span>
                                            <br />
                                            <span>17 Back River RdNew Norfolk TAS 7140</span>
                                        </div>
                                        <div class="section-chevron" style="display: none">
                                            <i class="fa-solid" :class="summary_sections.location_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </div>
                                        <b-collapse id="location-section">
                                            <div class="collapse-section-container" v-on:click.stop style="display: none;">
                                                <div class="summary-section-table">

                                                    <div style="position: relative; padding-left:20px; float: left;">
                                                        <span style="color:red; font-weight: bold;">LIVE DATA</span>
                                                        <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                                                            <circle cx="20" cy="20" r="5" fill="red" />
                                                        </svg> 
                                                    </div><span style="color: white;">x</span>

                                                    <div style="margin-top: -15px;">
                                                        <PackagingTracking_HuonTas_summary ref="PackagingTracking_HuonTas_summary"/>
                                                    </div>

                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>

                                    <!-- Financial Details  -->
                                    <div v-b-toggle.financial-section class="m-1 section-label section-label-last" @click="summary_sections.financial_expanded = !summary_sections.financial_expanded">
                                        <div class="section-icon"><i class="fa-solid fa-money-bill-trend-up"></i></div>
                                        <div class="section-label-details">
                                            <span><b>Financial</b></span>
                                            <br />
                                            <span>$65.00</span>
                                        </div>                                            
                                        <span class="section-chevron">
                                            <i class="fa-solid" :class="summary_sections.financial_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </span>
                                        <b-collapse id="financial-section">
                                            <div  class="collapse-section-container" v-on:click.stop>
                                                <div class="financial-section-heading"><b>Cost Breakdown</b></div>
                                                <table class="table">
                                                    <thead>
                                                        <th>Item</th>
                                                        <th>Process</th>
                                                        <th></th>
                                                        <th>Cost</th>
                                                    </thead>
                                                    <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.3')">
                                                        <td class="nft-cost-data-key">Packaging</td>
                                                        <td class="nft-cost-link"><a href="#">Process 2.3</a></td>
                                                        <td class="nft-cost-data-currency">$</td>
                                                        <td class="nft-cost-data-currency-value">55.00</td>
                                                    </tr>
                                                    <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.4')">
                                                        <td class="nft-cost-data-key">Cryoprotectant</td>
                                                        <td class="nft-cost-link"><a href="#">Process 2.4</a></td>
                                                        <td class="nft-cost-data-currency">$</td>
                                                        <td class="nft-cost-data-currency-value">2.00</td>
                                                    </tr>
                                                    <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('2.5')">
                                                        <td class="nft-cost-data-key">Preparation</td>
                                                        <td class="nft-cost-link"><a href="#">Process 2.5</a></td>
                                                        <td class="nft-cost-data-currency">$</td>
                                                        <td class="nft-cost-data-currency-value">0.00</td>
                                                    </tr>                                                                                                 
                                                    <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('3.2')">
                                                        <td class="nft-cost-data-key">Preservation</td>
                                                        <td class="nft-cost-link"><a href="#">Process 3.2</a></td>
                                                        <td class="nft-cost-data-currency">$</td>
                                                        <td class="nft-cost-data-currency-value">0.00</td>
                                                    </tr>
                                                    <tr class="hover-table" v-b-modal="'subprocess-detals-modal'" @click="transactionClick('5.3')">
                                                        <td class="nft-cost-data-key">Thawing</td>
                                                        <td class="nft-cost-link"><a href="#">Process 5.3</a></td>
                                                        <td class="nft-cost-data-currency nft-cost-data-bottom-border">$</td>
                                                        <td class="nft-cost-data-currency-value nft-cost-data-bottom-border">8.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="nft-cost-data-key"><b>Total</b></td>
                                                        <td class="nft-cost-link"></td>
                                                        <td class="nft-cost-data-currency nft-cost-data-bottom-border-thick">$</td>
                                                        <td class="nft-cost-data-currency-value nft-cost-data-bottom-border-thick">65.00</td>
                                                    </tr>                                                                                                                                                                                                              
                                                </table>
                                            </div>     
                                        </b-collapse>
                                    </div>

                                </div>
                            </div>

                        </b-tab>

                        <!-- flow tab -->
                        <b-tab title="Process Flow" active>

                            <!-- expand and collapse all -->
                            <div class="expandCollapse">
                                <a href="#" @click="expandAll()">expand all</a><span></span><a href="#" @click="collapseAll()">collapse all</a>
                            </div>
                            
                            <!-- dynamic template structure -->
                            <div id="template-container">
                                <div v-for="(milestone, index) in template.TempData.contract.milestones" v-bind:key="milestone.id">

                                    <!-- milestones -->
                                    <div class="milestone" :class="[milestone.status]" @click="milestoneToggle(milestone.id)">

                                        <!-- hide top left of top boarder over image -->
                                        <div style="border-top: 1px solid #ffffff; position: absolute; top: -1px; left: 0; width: 65px;"></div>

                                        <!-- icon Images -->
                                        <span>
                                            <!-- CAR-T & ART Icons -->
                                            <img v-if="milestone.iconImage == 1" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/1.png"/>
                                            <img v-if="milestone.iconImage == 2" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/2.png"/>
                                            <img v-if="milestone.iconImage == 3" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/3.png"/>
                                            <img v-if="milestone.iconImage == 4" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/4.png"/>
                                            <img v-if="milestone.iconImage == 5" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/5.png"/>
                                            <img v-if="milestone.iconImage == 6" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/6.png"/>
                                            <img v-if="milestone.iconImage == 7" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/7.png"/>
                                            <img v-if="milestone.iconImage == 8" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/8.png"/>
                                            <img v-if="milestone.iconImage == 9" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/9.png"/>
                                            <img v-if="milestone.iconImage == 10" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/10.png"/>
                                            <img v-if="milestone.iconImage == 11" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/11.png"/>
                                            <img v-if="milestone.iconImage == 12" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/12.png"/>

                                            <!-- Sperm Use Case NFT AI Test -->
                                            <img v-if="milestone.iconImage == 'SUCT-1'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/1.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-2'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/2.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-3'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/3.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-4'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/4.png"/>
                                            <img v-if="milestone.iconImage == 'SUCT-5'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/5.png"/>

                                            <img v-if="milestone.iconImage == 'SUCT-9'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/9.png"/>

                                        </span>

                                        <!-- milestone link -->
                                        <div v-if="milestone.status == 'COMPLETED' && index != template.TempData.contract.milestones.length -1" class="milestone-link" ></div>

                                        <!-- label -->
                                        <span v-if="milestone.status == 'IN PROGRESS'" class="milestone-label" style="font-weight: bold; color: #0a58ca"> {{ milestone.id }}. {{ milestone.name }} <span style="font-weight: initial; color: initial"><br />In Progress</span></span>
                                        <span v-else-if="milestone.status == 'COMPLETED'" class="milestone-label" style="font-weight: bold;"> {{ milestone.id }}. {{ milestone.name }} <span style="font-weight: initial; color: initial"><br />Completed - {{ milestone.timestamp }}</span></span>
                                        <span v-else class="milestone-label" style="color: #adb5bd"> {{ milestone.id }}. {{ milestone.name }} </span>

                                        <!-- chevron -->
                                        <i v-bind:class="[milestone.expanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down']"></i>

                                        <div v-if="milestone.lastMilestone && !milestone.expanded" class="milestone-link-end"></div>
                                    </div>

                                    <!-- subprocesses -->
                                    <div v-if="milestone.expanded" class="subprocess-section">
                                        
                                        <!-- links -->
                                        <div v-if="milestone.subprocesses.length > 0" :class="[milestone.status == 'COMPLETED' ? 'milestone-link-top milestone-link-top-complete' : 'milestone-link-top', milestone.status == 'IN PROGRESS' ? 'milestone-link-top milestone-link-top-complete' : 'milestone-link-top']"></div>
                                        <div v-if="milestone.subprocesses.length > 0 && !milestone.lastMilestone" :class="milestone.status == 'COMPLETED' ? 'milestone-link-bottom milestone-link-bottom-complete' : 'milestone-link-bottom'"></div>

                                        <!-- subprocess  (sl1)-->
                                        <div v-for="(s1, index) in milestone.subprocesses" v-bind:key="s1.id">
                                            <div class="subprocess-container">
                                                <div  style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                <div v-b-modal="'subprocess-detals-modal'" @click="sendInfo_subprocess(s1)" class="template-process" :class="[s1.status == 'COMPLETED' ? 'template-process-complete' : '', s1.status == 'IN PROGRESS' ? 'template-process-in-progress' : '']">
                                                    <div>{{ s1.id }} {{ s1.name }}</div>
                                                    <div v-if="!s1.subprocessesParallel && index != milestone.subprocesses.length - 1" :class="s1.status == 'COMPLETED' ? 'subprocess-bottom-link subprocess-bottom-link-complete' : 'subprocess-bottom-link'"></div>
                                                </div>
                                            </div>

                                            <!-- subprocess area -->
                                            <div class="subprocess-area">

                                                <!-- links -->
                                                <div v-if="s1.subprocesses.length > 0" :class="s1.status == 'COMPLETED' ? 'subprocess-link-top subprocess-link-top-complete' : 'subprocess-link-top'"></div>
                                                <div v-if="s1.subprocesses.length > 0 && !s1.linkBackToMilestone" :class="s1.status == 'COMPLETED' ? 'subprocess-link-bottom subprocess-link-bottom-complete' : 'subprocess-link-bottom'"></div>
                                                <div v-if="s1.linkBackToMilestone" :class="milestone.status == 'COMPLETED' ? 'subprocess-link-back-to-milestone subprocess-link-back-to-milestone-complete' : 'subprocess-link-back-to-milestone'"></div>
                                                <div v-if="s1.subprocessesParallel" :class="s1.status == 'COMPLETED' ? 'subprocesses-parallel-link subprocesses-parallel-link-complete' : 'subprocesses-parallel-link'"></div>

                                                <!-- subprocess of subprocesses (sl2) -->
                                                <div v-for="(s2, index) in s1.subprocesses" v-bind:key="s2.id">
                                                    <div class="subprocess-container">
                                                        <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                        <div style="float: left;" class="template-process blank-process"></div>

                                                        <div v-b-modal="'subprocess-detals-modal'" @click="sendInfo_subprocess(s2)" class="template-process" :class="[s2.status == 'COMPLETED' ? 'template-process-complete' : '', s2.status == 'IN PROGRESS' ? 'template-process-in-progress' : '']">
                                                            <div>{{ s2.id }} {{ s2.name }}</div>
                                                            <div v-if="!s2.isParallel && index != s1.subprocesses.length - 1" :class="s2.status == 'COMPLETED' ? 'subprocess-bottom-link subprocess-bottom-link-complete' : 'subprocess-bottom-link'"></div>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- subprocess area -->
                                                    <div class="subprocess-area">

                                                        <!-- links -->
                                                        <div v-if="s2.subprocesses.length > 0" :class="s2.status == 'COMPLETED' ? 'subprocess-subprocess-link-top subprocess-subprocess-link-top-complete' : 'subprocess-subprocess-link-top'"></div>
                                                        <div v-if="s2.subprocesses.length > 0" :class="s2.status == 'COMPLETED' ? 'subprocess-subprocess-link-bottom subprocess-subprocess-link-bottom-complete' : 'subprocess-subprocess-link-bottom'"></div>
                                                        <div v-if="s2.subprocessesParallel" :class="s2.status == 'COMPLETED' ? 'subprocesses-subprocess-parallel-link subprocesses-subprocess-parallel-link-complete' : 'subprocesses-subprocess-parallel-link'"></div>

                                                        <!-- subprocess of subprocesses of subprocesses (sl3) -->
                                                        <div v-for="s3 in s2.subprocesses" v-bind:key="s3.id">
                                                            <div class="subprocess-container">
                                                                <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                                <div style="float: left;" class="template-process blank-process"></div>
                                                                <div style="float: left;" class="template-process blank-process"></div>
                                                                
                                                                <div v-b-modal="'subprocess-detals-modal'" @click="sendInfo_subprocess(s3)" class="template-process" :class="[s3.status == 'COMPLETED' ? 'template-process-complete' : '', s3.status == 'IN PROGRESS' ? 'template-process-in-progress' : '']">
                                                                    <div>{{ s3.id }} {{ s3.name }}</div>
                                                                    <div v-if="!s3.isParallel" class="subprocess-bottom-link"></div>
                                                                </div>
                                                            </div>

                                                        </div> 

                                                    </div>

                                                </div>

                                            </div>
                                            
                                        </div>

                                    </div>

                                </div>
                                <div id="hide-end-of-line"></div>
                            </div>

                        </b-tab>

                        <!-- transactions tab -->
                        <b-tab title="Transactions">
                            
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">TimeStamp</th>
                                        <th scope="col">Process</th>
                                        <!-- <th scope="col">Authoriser</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="transaction in contractHistory" v-bind:key="transaction.Timestamp" class="hover-table">
                                        <td> {{ transaction.TimeStamp }} </td>
                                        <td> 
                                            <div v-if="transaction.State == '0'">Contract Created</div>
                                            <div v-else>{{ transaction.State }} {{ transaction.Name }} - Completed</div>
                                        </td>
                                        <!-- <td> {{ transaction.User }} </td> -->
                                    </tr>
                                </tbody>
                            </table>

                        </b-tab>

                    </b-tabs>
                </div>

            </div>

        </b-modal>

        <!-- subprocess details modal (process details)-->
        <b-modal id="subprocess-detals-modal" size="xl" title="Process Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">

            <!-- contract details -->
            <div id="blockchain-modal">

                <!-- contract summary -->
                <table class="blockchain-info-table">
                    <tr>
                        <td style="padding-right: 10px;"><b>Process Name</b></td>
                        <td>{{ selectedSubprocess.id }} {{ selectedSubprocess.name }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>Contract Name</b></td>
                        <td>{{ selectedBlock.name }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>Template Name</b></td>
                        <td>{{ template.TempData.contract.name }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>Process Status</b></td>
                        <td v-if="selectedSubprocess.status == 'IN PROGRESS'" style="color: #0a58ca; font-weight: 700;">{{ selectedSubprocess.status }} </td>
                        <td v-else-if="selectedSubprocess.status == 'COMPLETED'" style="color: #198754; font-weight: 700;">{{ selectedSubprocess.status }} </td>
                        <td v-else> {{ selectedSubprocess.status }} </td>
                    </tr>
                    <tr v-if="selectedSubprocess.status == 'COMPLETED'">
                        <td style="padding-right: 10px;"><b>TimeStamp</b></td>
                        <td> {{ selectedSubprocess.timestamp }} </td>
                    </tr>
                </table>

                <!-- standard complete process button -->
                <button v-if="selectedSubprocess.status == 'IN PROGRESS'" type="button" class="btn btn-primary btn-sm" @click="subprocessComplete(selectedSubprocess)" style="float: right;">
                    <font-awesome-icon icon="fa-solid fa-check" /><span style="padding-left: 10px;">Complete Process</span>
                </button> 

            </div>
        </b-modal>     

        <!-- Template details  Modal -->
        <b-modal id="modal-3" size="lg" title="Template Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">

            <div id="blockchain-modal">

                <!-- template summary -->
                <table class="blockchain-info-table">
                    <tr>
                        <td style="padding-right: 10px;"><b>Template Name</b></td>
                        <td>{{template.TempData.contract.name }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>Template ID</b></td>
                        <td>{{template.TempData.contract.id }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>Application</b></td>
                        <td>{{template.TempData.contract.application }}</td>
                    </tr>                        
                    <tr>
                        <td style="padding-right: 10px;"><b>Created</b></td>
                        <td>{{template.TimeStamp }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>Created by</b></td>
                        <td>{{template.User }}</td>
                    </tr>   
                    <tr>
                        <td style="padding-right: 10px;"><b>Template Owner</b></td>
                        <td>{{template.Owner }}</td>
                    </tr>     
                    <tr>
                        <td style="padding-right: 10px;"><b>Current State</b></td>
                        <td>{{template.State }}</td>
                    </tr>
                </table>

                <br />

                <!-- tabs -->
                <b-tabs content-class="mt-3">

                    <!-- milestones view -->
                    <b-tab title="Process Flow" active>

                        <!-- expand and collapse all -->
                        <div class="expandCollapse">
                            <a href="#" @click="expandAll()">expand all</a><span></span><a href="#" @click="collapseAll()">collapse all</a>
                        </div>
                        
                        <!-- dynamic template structure -->
                        <div id="template-container">
                            <div v-for="milestone in template.TempData.contract.milestones" v-bind:key="milestone.id">

                                <!-- milestones -->
                                <div class="milestone" :class="[milestone.status]" @click="milestoneToggle(milestone.id)">
                                    
                                    <!-- icon Images -->
                                    <span>
                                        <!-- CAR-T & ART Icons -->
                                        <img v-if="milestone.iconImage == 1" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/1.png"/>
                                        <img v-if="milestone.iconImage == 2" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/2.png"/>
                                        <img v-if="milestone.iconImage == 3" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/3.png"/>
                                        <img v-if="milestone.iconImage == 4" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/4.png"/>
                                        <img v-if="milestone.iconImage == 5" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/5.png"/>
                                        <img v-if="milestone.iconImage == 6" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/6.png"/>
                                        <img v-if="milestone.iconImage == 7" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/7.png"/>
                                        <img v-if="milestone.iconImage == 8" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/8.png"/>
                                        <img v-if="milestone.iconImage == 9" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/9.png"/>
                                        <img v-if="milestone.iconImage == 10" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/10.png"/>
                                        <img v-if="milestone.iconImage == 11" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/11.png"/>
                                        <img v-if="milestone.iconImage == 12" class="milestone-image contractImageNotActioned" src="../../assets/images/templateIcons/12.png"/>

                                        <!-- Sperm Use Case NFT AI Test -->
                                        <img v-if="milestone.iconImage == 'SUCT-1'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/1.png"/>
                                        <img v-if="milestone.iconImage == 'SUCT-2'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/2.png"/>
                                        <img v-if="milestone.iconImage == 'SUCT-3'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/3.png"/>
                                        <img v-if="milestone.iconImage == 'SUCT-4'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/4.png"/>
                                        <img v-if="milestone.iconImage == 'SUCT-5'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/5.png"/>

                                        <img v-if="milestone.iconImage == 'SUCT-9'" class="milestone-image" :class="[milestone.status == 'COMPLETED' ? '' : 'contractImageNotActioned', milestone.status == 'IN PROGRESS' ? 'contractImageInProgress' : '']" src="../../assets/images/templateIcons/testIcons/9.png"/>

                                    </span>

                                    <!-- label -->
                                    <span class="milestone-label"> {{ milestone.id }}. {{ milestone.name }} </span>

                                    <!-- chevron -->
                                    <i v-bind:class="[milestone.expanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down']"></i>

                                    <div v-if="milestone.lastMilestone && !milestone.expanded" class="milestone-link-end"></div>
                                </div>

                                <!-- subprocesses -->
                                <div v-if="milestone.expanded" class="subprocess-section">
                                    
                                    <!-- links -->
                                    <div v-if="milestone.subprocesses.length > 0" class="milestone-link-top"></div>
                                    <div v-if="milestone.subprocesses.length > 0 && !milestone.lastMilestone" class="milestone-link-bottom"></div>

                                    <!-- subprocess -->
                                    <div v-for="(subprocess, index) in milestone.subprocesses" v-bind:key="subprocess.id">
                                        <div class="subprocess-container">
                                            <div style="float: left;" class="template-process blank-process first-coloum-process"></div>

                                            <div class="template-process" :class="[subprocess.status]">
                                                {{ subprocess.id }} {{ subprocess.name }}
                                                <!-- <div class="subprocess-bottom-link"></div> -->
                                                <div v-if="!subprocess.subprocessesParallel && index != milestone.subprocesses.length - 1" class=subprocess-bottom-link></div>
                                            </div>
                                        </div>

                                        <!-- subprocess area -->
                                        <div class="subprocess-area">

                                            <!-- links -->
                                            <div v-if="subprocess.subprocesses.length > 0" class="subprocess-link-top"></div>
                                            <div v-if="subprocess.subprocesses.length > 0 && !subprocess.linkBackToMilestone" class="subprocess-link-bottom"></div>
                                            <div v-if="subprocess.linkBackToMilestone" class="subprocess-link-back-to-milestone"></div>
                                            <div v-if="subprocess.subprocessesParallel" class="subprocesses-parallel-link"></div>

                                            <!-- subprocess -->
                                            <div v-for="subprocess in subprocess.subprocesses" v-bind:key="subprocess.id">
                                                <div class="subprocess-container">
                                                    <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                    <div style="float: left;" class="template-process blank-process"></div>

                                                    <div class="template-process" :class="[subprocess.status]">
                                                        {{ subprocess.id }} {{ subprocess.name }}
                                                        <div v-if="!subprocess.isParallel" class="subprocess-bottom-link"></div>
                                                    </div>
                                                </div>
                                                
                                                <!-- subprocess area -->
                                                <div class="subprocess-area">

                                                    <!-- links -->
                                                    <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-link-top"></div>
                                                    <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-link-bottom"></div>
                                                    <div v-if="subprocess.subprocessesParallel" class="subprocesses-subprocess-parallel-link"></div>

                                                    <!-- subprocess of subprocesses-->
                                                    <div v-for="subprocess in subprocess.subprocesses" v-bind:key="subprocess.id">
                                                        <div class="subprocess-container">
                                                            <div style="float: left;" class="template-process blank-process first-coloum-process"></div>
                                                            <div style="float: left;" class="template-process blank-process"></div>
                                                            <div style="float: left;" class="template-process blank-process"></div>
                                                            
                                                            <div class="template-process" :class="[subprocess.status]">
                                                                {{ subprocess.id }} {{ subprocess.name }}
                                                                <div v-if="!subprocess.isParallel" class="subprocess-bottom-link"></div>
                                                            </div>
                                                        </div>

                                                    </div> 
                                                    <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-subprocess-bottom-link-blank"></div>

                                                </div>

                                            </div>
                                            <div v-if="subprocess.subprocesses.length > 0" class="subprocess-subprocess-bottom-link-blank"></div>

                                        </div>
                                        
                                    </div>
                                    <div class="subprocess-bottom-link-blank"></div>

                                </div>

                            </div>
                            <div id="hide-end-of-line"></div>
                        </div>

                    </b-tab>

                    <!-- code view -->
                    <b-tab title="Code (JSON) View">
                        <pre><code>{{ template }}</code></pre>
                    </b-tab>

                </b-tabs>

            </div>
       
        </b-modal>


    </div>
</template>

<script>
    import UserInfoStore from '../../app/user-info-store';

    export default {
        name: 'BlockchainTestDashboard',
        components: {
        },
        data: function () {
            return {
                test: "BlockchainTestDashboard test",
                assetCount: 0,
                blockchain: [],
                UserInfoStore: UserInfoStore,
                contractName: null,
                contractTemplate: "954b11cc-c469-4e4f-80e9-30376cff9d03",
                contractApplication: "CAT-T",
                contractHistory: [],
                templates : [],
                template: null,
                selectedBlock : {
                    ID: null,
                    Owner: null,
                    State: null,
                    TempData: null,
                    TimeStamp: null,
                    User: null
                },
                selectedSubprocess: {
                    id: null,
                    name: null,
                    status: null,
                },
                subprocess_input_validated: true,                           
            };
        },
        props: [],
        watch: {},
        methods: {      
            openBlock(block) {
                console.log(block.ID);

                this.selectedBlock.ID = block.ID;
                this.selectedBlock.name = block.ID.split(":")[2];
                this.selectedBlock.Owner = block.Owner;
                this.selectedBlock.State = block.State;
                this.selectedBlock.TempData = block.TempData;
                this.selectedBlock.TimeStamp = block.TimeStamp;
                this.selectedBlock.User = block.User;

                this.readAsset();
            },
            async GetAllAssets() {
                console.log("GetAllAssets test buton clicked man");

                try {
                    let url = process.env.VUE_APP_ML_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "endpoint": "/blockchain//GetAllAssets"
                    };

                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);

                    var filteredBlockchain = [];

                    var templates = [];

                    for(var i = 0; i < response.data.length; i++) {
                        if(response.data[i].State != "TEST") {
                            filteredBlockchain.push(response.data[i]);
                        }
                        if(response.data[i].State == "TEMPLATE") {
                            response.data[i].TempData = JSON.parse(response.data[i].TempData);
                            templates.push(response.data[i]);
                        }                        
                    }

                    this.templates = templates;

                    if(templates.length > 0) {
                        //console.log("this.templates[0].TempData.contract.application: " + this.templates[0].TempData.contract.application);
                        this.template = this.templates[0];
                    }

                    for(var x = 0; x < filteredBlockchain.length; x++) {
                        console.log(filteredBlockchain[x]);

                        // convert TempData string into JSON
                        //filteredBlockchain[x].TempData = JSON.parse(filteredBlockchain[x].TempData);
                    }

                    // this.blockchain = response.data;
                    this.blockchain = filteredBlockchain;
                    this.assetCount = filteredBlockchain.length;
                } catch (error) {
                    console.log(error);
                }
            },
            async CreateAsset() {
                console.log("CreateAsset test buton clicked man");

                var blockId = this.$parent.uuidv4();
                var timestamp = new Date().getTime();
                blockId = blockId + ":" + timestamp + ":" + this.contractName;
                
                console.log("blockId: " + blockId);
                console.log("timestamp: " + timestamp);
                console.log("blockId: " + blockId);

                var tempdata = {
                    "TemplateID": this.contractTemplate,
                    "Application": this.contractApplication
                }

                // FOR ADDING CONTRACT
                // tempdata = {
                //     "contract": {
                //         "id": "954b11cc-c469-4e4f-80e9-30376cff9d03",
                //         "name": "CAR-T (Chimeric Antigen Receptor T-Cell) Therapy - Template",
                //         "application": "CAR-T",
                //         "version": "1.0",
                //         "status": null,
                //         "details": "CAR-T Smart Contract",
                //         "milestones": [{
                //                 "id": "1",
                //                 "name": "Doctor Patient Identification",
                //                 "iconImage": "1",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "1.1",
                //                         "name": "Doctor registered",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "1.2",
                //                         "name": "Donor/Patient details creation",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "2",
                //                 "name": "Patient Collection",
                //                 "iconImage": "2",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "2.1",
                //                         "name": "Identification of biological materia selected",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "2.2",
                //                         "name": "Sample volume identified",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "2.3",
                //                         "name": "The MIoT packaging device informed",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "3",
                //                 "name": "Isolation Leukapheresis",
                //                 "iconImage": "3",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "3.1",
                //                         "name": "Collection",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "3.2",
                //                         "name": "Pre-cryopreservation",
                //                         "status": null,
                //                         "linkBackToMilestone": true,
                //                         "subprocesses": [{
                //                                 "id": "3.2.1",
                //                                 "name": "Pre-cryopreservation processing",
                //                                 "status": null,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "3.2.2",
                //                                 "name": "Selection of MIoT packaging",
                //                                 "status": null,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "3.2.3",
                //                                 "name": "Monitoring",
                //                                 "status": null,
                //                                 "subprocessesParallel": true,
                //                                 "subprocesses": [{
                //                                         "id": "3.2.3.1",
                //                                         "name": "Temprature Monitoring",
                //                                         "status": null,
                //                                         "isParallel": true,
                //                                         "subprocesses": []
                //                                     },
                //                                     {
                //                                         "id": "3.2.3.2",
                //                                         "name": "Tracking",
                //                                         "status": null,
                //                                         "isParallel": true,
                //                                         "subprocesses": []
                //                                     }
                //                                 ]
                //                             },
                //                             {
                //                                 "id": "3.2.4",
                //                                 "name": "Holding until cryopreservation",
                //                                 "status": null,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "3.2.5",
                //                                 "name": "MIoT cryopreservation device informed",
                //                                 "status": null,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "3.2.6",
                //                                 "name": "Select racking system and protocol",
                //                                 "status": null,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "3.2.7",
                //                                 "name": "MIoT smart packaging device will inform other devices",
                //                                 "status": null,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "4",
                //                 "name": "Vitrafy Controlled Cryopreservation",
                //                 "iconImage": "4",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "4.1",
                //                         "name": "Monitoring",
                //                         "status": null,
                //                         "subprocessesParallel": true,
                //                         "subprocesses": [{
                //                                 "id": "4.1.1",
                //                                 "name": "Cryopreservation Temperature Monitoring",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "4.1.2",
                //                                 "name": "Protocol and Cost Tracking",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "4.2",
                //                         "name": "Cryopreservation",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "5",
                //                 "name": "Specialised Logistics",
                //                 "iconImage": "5",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "5.1",
                //                         "name": "Monitoring",
                //                         "status": null,
                //                         "subprocessesParallel": true,
                //                         "subprocesses": [{
                //                                 "id": "5.1.1",
                //                                 "name": "Temperature Monitoring",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "5.1.2",
                //                                 "name": "Location Tracking",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "5.2",
                //                         "name": "Identification of Target destination",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "6",
                //                 "name": "Vitrafy Controlled Biothaw",
                //                 "iconImage": "6",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "6.1",
                //                         "name": "Monitoring",
                //                         "status": null,
                //                         "subprocessesParallel": true,
                //                         "subprocesses": [{
                //                                 "id": "6.1.1",
                //                                 "name": "Temperature Monitoring",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "6.1.2",
                //                                 "name": "Protocol and Cost Tracking",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "6.2",
                //                         "name": "Protocol Selection",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "6.3",
                //                         "name": "Thawing",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "7",
                //                 "name": "Differentiation Transformation",
                //                 "iconImage": "7",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "7.1",
                //                         "name": "DNA Plasmid Process",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "7.2",
                //                         "name": "Cell Process",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "7.3",
                //                         "name": "MIoT packaging checks",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "8",
                //                 "name": "Expansion",
                //                 "iconImage": "8",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "8.1",
                //                         "name": "Biological material expanded",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "8.2",
                //                         "name": "Determine if subsequent cycles are required",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "8.3",
                //                         "name": "Holding until cryopreservation",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "8.4",
                //                         "name": "MIoT Cryopreservation device informed",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "8.5",
                //                         "name": "Select racking system and protocol",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "9",
                //                 "name": "Vitrafy Controlled Cryopreservation",
                //                 "iconImage": "9",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "9.1",
                //                         "name": "Monitoring",
                //                         "status": null,
                //                         "subprocessesParallel": true,
                //                         "subprocesses": [{
                //                                 "id": "9.1.1",
                //                                 "name": "Cryopreservation Temperature Monitoring",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "9.1.2",
                //                                 "name": "Protocol and Cost Tracking",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "9.2",
                //                         "name": "Cryopreservation",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "10",
                //                 "name": "Specialised Logistics",
                //                 "iconImage": "10",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "10.1",
                //                         "name": "Monitoring",
                //                         "status": null,
                //                         "subprocessesParallel": true,
                //                         "subprocesses": [{
                //                                 "id": "10.1.1",
                //                                 "name": "Temperature Monitoring",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "10.1.2",
                //                                 "name": "Location Tracking",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "10.2",
                //                         "name": "Identification of Target destination",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "11",
                //                 "name": "Vitrafy Controlled Biothaw",
                //                 "iconImage": "11",
                //                 "status": null,
                //                 "expanded": false,
                //                 "subprocesses": [{
                //                         "id": "11.1",
                //                         "name": "Monitoring",
                //                         "status": null,
                //                         "subprocessesParallel": true,
                //                         "subprocesses": [{
                //                                 "id": "11.1.1",
                //                                 "name": "Temperature Monitoring",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             },
                //                             {
                //                                 "id": "11.1.2",
                //                                 "name": "Protocol and Cost Tracking",
                //                                 "status": null,
                //                                 "isParallel": true,
                //                                 "subprocesses": []
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "11.2",
                //                         "name": "Protocol Selection",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "11.3",
                //                         "name": "Thawing",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             },
                //             {
                //                 "id": "12",
                //                 "name": "Transplant",
                //                 "iconImage": "12",
                //                 "status": null,
                //                 "expanded": false,
                //                 "lastMilestone": true,
                //                 "subprocesses": [{
                //                         "id": "12.1",
                //                         "name": "Doctor, Patient & biological material identified",
                //                         "status": null,
                //                         "subprocesses": []
                //                     },
                //                     {
                //                         "id": "12.2",
                //                         "name": "Transplant process",
                //                         "status": null,
                //                         "subprocesses": []
                //                     }
                //                 ]
                //             }
                //         ]
                //     }
                // }
                // blockId = "374a2953-1f22-440d-97ae-088161bd38b3";
                // END

                tempdata = JSON.stringify(tempdata);                



                try {
                    let url = process.env.VUE_APP_ML_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "endpoint": "/blockchain//CreateAsset",
                        "data": {
                            "ID": blockId,
                            "TimeStamp": timestamp.toString(),
                            "State": "0",
                            "Owner": "Vitrafy (version 4)",
                            "User": this.$parent.userInfo.username,
                            "TempData": tempdata
                        }                        
                    };

                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);
                    this.GetAllAssets();

                } catch (error) {
                    console.log(error);
                }
            },
            async UpdateAsset() {
                console.log("UpdateAsset test buton clicked man");

                var timestamp = new Date().getTime();

                try {
                    let url = process.env.VUE_APP_ML_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "endpoint": "/blockchain//UpdateAsset",
                        "data": {
                            "ID": this.selectedBlock.ID,
                            "TimeStamp": timestamp,
                            "State": this.selectedBlock.State,
                            "Owner": this.selectedBlock.Owner,
                            "User": this.selectedBlock.User,
                            "TempData": this.selectedBlock.TempData
                        }
                    };

                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);
                    this.GetAllAssets();

                } catch (error) {
                    console.log(error);
                }
            },
            async subprocessComplete(subprocess) {
                console.log("subprocess.ID: " + subprocess.id);

                var timestamp = new Date().getTime();

                try {
                    let url = process.env.VUE_APP_ML_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "endpoint": "/blockchain//UpdateAsset",
                        "data": {
                            "ID": this.selectedBlock.ID,
                            "TimeStamp": timestamp,
                            "State": subprocess.id,
                            "Owner": this.selectedBlock.Owner,
                            "User": this.selectedBlock.User,
                            "TempData": this.selectedBlock.TempData
                        }
                    };

                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);
                    this.GetAllAssets();

                } catch (error) {
                    console.log(error);
                }
            },
            async readAsset() {
                await this.GetAllAssets();

                console.log("read asset button clicked man");

                try {
                    let url = process.env.VUE_APP_ML_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "endpoint": "/blockchain//ReadAssetHistory",
                        "data": {
                            "ID": this.selectedBlock.ID,
                        }
                    };

                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);

                    this.contractHistory = response.data;

                    this.loadHistoryIntoTemplate();
                } catch (error) {
                    console.log(error);
                }
            },     
            loadHistoryIntoTemplate() {
                console.log("loadHistoryIntoTemplate");

                // // check if conttract has juut been created
                if(this.contractHistory.length == 1) {
                    // for new contracts set to milestone 1 and subprocess 1.1
                    this.template.TempData.contract.milestones[0].status = "IN PROGRESS";
                    this.template.TempData.contract.milestones[0].subprocesses[0].status = "IN PROGRESS";
                } else {
                    for(var i = 0; i < this.contractHistory.length; i++) {
                        // milestones
                        for(var x = 0; i < this.template.TempData.contract.milestones.length; i++) {
                            // subprocess (l1)
                            for(var y = 0; y < this.template.TempData.contract.milestones[x].subprocesses.length; y++) {
                                // mark completed subprocesses
                                if(this.contractHistory.status == this.template.TempData.contract.milestones[x].subprocesses[y].status) {
                                    this.template.TempData.contract.milestones[x].subprocesses[y].status = "COMPLETED"

                                    // mark completed milestone
                                    if(y == this.template.TempData.contract.milestones[x].subprocesses.length) {
                                        this.template.TempData.contract.milestones[x].status = "COMPLETED"
                                    }                                      
                                }                              
                            }                            
                        }
                    }
                }





            },       
            milestoneToggle(id) {
                if (this.template.TempData.contract.milestones[(id -1)].expanded) {
                    this.template.TempData.contract.milestones[(id -1)].expanded = false;
                } else {
                    this.template.TempData.contract.milestones[(id -1)].expanded = true;
                }
            },
            expandAll() {
                for(var i = 0; i < this.template.TempData.contract.milestones.length; i++) {
                    this.template.TempData.contract.milestones[i].expanded = true;
                }
                this.contractAllExpanded = true;
            },
            collapseAll() {
                for(var i = 0; i < this.template.TempData.contract.milestones.length; i++) {
                    this.template.TempData.contract.milestones[i].expanded = false;
                }
                this.contractAllExpanded = false;
            },
            sendInfo_subprocess(subprocess) {
                console.log("Send info subprocess: ", subprocess)
                this.selectedSubprocess = subprocess;

                this.testLocationLoaded = false;
                this.process_location = "";
                this.infoBoxClosed_location = true;
                this.infoBoxClosed_patient = true;
                this.infoBoxClosed_doctor = true;
                this.infoBoxClosed_sample = true;
                this.infoBoxClosed_sample_checks = true;
                this.infoBoxClosed_sample_reg = true;
                this.infoBoxClosed_device = true;
                this.infoBoxClosed_process = true;

                // find transaction and add timestamp
                for(var i = 0; i < this.block_history.length; i++) {
                    if (this.block_history[i].State == subprocess.id) {
                        console.log("FOUND! " + subprocess.id);
                        this.selectedSubprocess.timestamp = this.block_history[i].TimeStamp;
                    }
                }

            }                                            
        },
        mounted: function () {
            this.GetAllAssets();
        }
    }
</script>

<style scoped>

    #blockchain-container {
        overflow-y: auto; 
        overflow-x: auto;
    }

    #blockchain-header-container {
        float: left; 
        width: 100%; 
        margin-bottom: 10px;
    }

    #blockchain-heading {
        float: left;
    }

    .blockchain-info-table {
        margin-bottom: 0px;
    }

    #blockchain-button-container {
        float: right;
    }

    .end-of-chain, .modal-footer {
        background-color: #fff;
        z-index: 99;
    }

    /* template css */
    #template-container {
        position: relative;
    }

    #hide-end-of-line {
        position: absolute;
        bottom: -10px;
        left: 36px;
        height: 10px;
        width: 10px;
        background: white;
    }    

    #template-container:before {
        position: absolute;
        top: 9px;
        left: 36px;
        display: block;
        content: "";
        width: 3px;
        height: 100%;
        background-color: red;
        display: none;
    }

    .milestone-container:before {
        position: absolute;
        top: 0;
        left: 36px;
        display: block;
        content: "";
        width: 3px;
        height: 100%;
        background-color: grey;
    }

    .milestone {
        position: relative;
        width: 100%;
        height: 70px;
        padding: 10px;
        border-top: 1px solid #e6ebf1;
        display: flex;
        align-items: center;
        justify-content: left;
    }

    .milestone-link-end {
        position: absolute;
        width: 11px;
        height: 9px;
        background: white;
        top: 61px;
        left: 32px;   
    }

    .milestone:hover {
        cursor: pointer;
    }

    /* milestone links */
    .milestone-link {
        position: absolute; 
        top: 60px; 
        left: 35px; 
        border-left: 3px solid #00ad5b; 
        width: 3px; 
        height: 18px; 
        z-index: 1;
    }

    .subprocess-section {
        position: relative;
        background: white;
    }

    .milestone-link-top {
        z-index: 2;
        position: absolute;
        top: -11px;
        left: 35px;
        display: block;
        content: "";
        width: 60px;
        height: 47px;
        /* background-color: white; */
        border-left: 3px dashed lightgrey;
        border-bottom: 3px dashed lightgrey;
    }

    .milestone-link-top-complete {
        border-left: 3px solid rgb(0, 173, 91);
        border-bottom: 3px solid rgb(0, 173, 91);
    }

    .milestone-link-top-inprogress {
        border-left: 3px solid red;
        border-bottom: 3px solid red;
    }    

    .milestone-link-bottom {
        position: absolute;
        bottom: -29px;
        left: 35px;
        display: block;
        content: "";
        width: 60px;
        height: 66px;
        /* background-color: white; */
        border-left: 3px dashed lightgrey;
        border-top: 3px dashed lightgrey;
        z-index: 1;
    }

    .milestone-link-bottom-complete {
        border-left: 3px solid rgb(0, 173, 91);
        border-top: 3px solid rgb(0, 173, 91);
    }    

    /* subprocess links */
    .subprocess-area {
        position: relative;
    }

    .subprocess-link-top {
        position: absolute;
        top: -20px;
        left: 180px;
        display: block;
        width: 103px;
        height: 57px;
        background-color: white;
        border-left: 3px dashed lightgrey;
        border-bottom: 3px dashed lightgrey;
    }

    .subprocess-link-top-complete{
        border-left: 3px solid rgb(0, 173, 91);
        border-bottom: 3px solid rgb(0, 173, 91);
        z-index: 1;
    }    


    .subprocess-link-bottom {
        position: absolute;
        bottom: -20px;
        left: 180px;
        display: block;
        width: 103px;
        height: 57px;
        background-color: white;
        border-left: 3px dashed lightgrey;
        border-top: 3px dashed lightgrey;
    }

    .subprocess-link-bottom-complete {
        border-left: 3px solid rgb(0, 173, 91);
        border-top: 3px solid rgb(0, 173, 91);
    }    

    .subprocess-link-back-to-milestone {
        position: absolute;
        bottom: -20px;
        left: 95px;
        display: block;
        width: 188px;
        height: 57px;
        background-color: white;
        border-top: 3px dashed lightgrey;
    }

    .subprocess-link-back-to-milestone-complete {
        border-top: 3px solid rgb(0, 173, 91);
    }    

    .subprocesses-parallel-link {
        position: absolute;
        top: 37px;
        left: 180px;
        display: block;
        width: 3px;
        height: 86px;
        border-left: 3px dashed lightgrey;
    }

    .subprocesses-parallel-link-complete {
        border-left: 3px solid rgb(0, 173, 91);
    }    

    .subprocesses-subprocess-parallel-link {
        position: absolute;
        top: 37px;
        left: 368px;
        display: block;
        width: 3px;
        height: 86px;
        border-left: 3px dashed lightgray;
    }

    .subprocesses-subprocess-parallel-link-complete {
        border-left: 3px solid rgb(0, 173, 91);
    }        

    /* subprocess subprocess links */
    .subprocess-subprocess-link-top {
        position: absolute;
        top: 0px;
        left: 368px;
        display: block;
        width: 103px;
        height: 37px;
        background-color: white;
        border-left: 3px dashed lightgrey;
        border-bottom: 3px dashed lightgrey;
    }

    .subprocess-subprocess-link-top-complete {
        top: -20px;
        height: 57px;
        border-left: 3px solid rgb(0, 173, 91);
        border-bottom: 3px solid rgb(0, 173, 91);
    }

    .subprocess-subprocess-link-bottom {
        position: absolute;
        bottom: -20px;
        left: 368px;
        display: block;
        width: 103px;
        height: 57px;
        background-color: white;
        border-left: 3px dashed lightgrey;
        border-top: 3px dashed lightgrey;
    }

    .subprocess-subprocess-link-bottom-complete {
        border-left: 3px solid rgb(0, 173, 91);
        border-top: 3px solid rgb(0, 173, 91);
    }    

    /* subprocess bottom links */
    .subprocess-bottom-link {
        position: absolute;
        bottom: -22px;
        left: 84px;
        display: block;
        content: "";
        width: 3px;
        height: 21px;
        border-right: 3px dashed lightgrey;
    }

    .subprocess-bottom-link-complete {
        border-right: 3px solid rgb(0, 173, 91);
    }

    .subprocess-bottom-link-blank {
        position: absolute;
        bottom: -21px;
        left: 180px;
        display: block;
        content: "";
        width: 3px;
        height: 21px;
        background-color: white;
    }    

    .subprocess-subprocess-bottom-link-blank {
        position: absolute;
        bottom: -21px;
        left: 368px;
        display: block;
        content: "";
        width: 3px;
        height: 21px;
        background-color: white;
    }     

    .subprocess-subprocess-subprocess-bottom-link-blank {
        position: absolute;
        bottom: -21px;
        left: 556px;
        display: block;
        content: "";
        width: 3px;
        height: 21px;
        background-color: white;
    }         

    /* milestones */
    .milestone i {
        float: right;
        font-size: 18px;
    }

    .milestone-image {
        width: 53px;
        border: 3px solid #00ad5b;
        border-radius: 50%;
        position: relative;
        z-index: 3;
    }

    .contractImageNotActioned {
        filter: grayscale(100%) brightness(90%);
        border: 3px solid #e6ebf1;
    }

    .contractImageInProgress {
        z-index: 4 !important;
        filter: none !important;
        border: 3px solid #0a58ca !important;
        box-shadow: 0px 0px 8px 1px #0a58ca !important;
    }

    .milestone-label {
        padding-left: 20px;
        width: 100%;
    }

    .template-process {
        position: relative;
        height: 70px;
        width: 178px;
        border: 1px solid grey;
        color: grey;
        padding: 10px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        margin-left: 5px;
        margin-right: 5px;
        background: white;
        z-index: 1;
    }

    .blank-process {
        border: none;
        background: none;
    }

    .first-coloum-process {
        width: 85px;
    }

    .InProgress {
        border: 1px solid blue;
        color: initial;
    }

    .Complete {
        border: 1px solid green;
        color: initial;
    }

    .expandCollapse {
        text-align: right;
        margin-bottom: 15px;
    }

    .expandCollapse span {
        padding-left: 10px;
    }

    .template-process-complete {
        border: 1px solid #196240;
        background-color: #44ab88;
        color: #fff;
    }

    .template-process-in-progress {
        box-shadow: 0px 0px 8px 1px #0a58ca;
        color: white;
        background-color: #3978d3;
        border: 1px solid #033276;

    }

    .hover-table:hover {
        background: #f5f5f5;
        cursor: pointer;
    }

    /* 1.2 Master NFT Creation */
    .process-wizard-container {
        width: 100%; 
        float: left; 
        padding: 20px; 
        padding-top: 10px;
        padding-bottom: 0;
        padding-right: 0;
    }

    .process-wizard-steps {
        width: 25%; 
        float: left; 
        padding: 20px; 
        border-right: 1px solid #C7C8C9;
    }

    .process-wizard-step-padding {
        padding-bottom: 20px;
    }

    .process-wizard-step-icon-container {
        position: relative;
        vertical-align: top;
        font-size: 20px;
    }

    .process-wizard-step-icon {
        position: absolute;
        z-index: 1;
    }

    .process-wizard-summary-link {
        position: absolute;
        top: 7px;
        left: 9px;
        width: 3px;
        height: 100%;
        border-right: 3px solid lightgrey;
    }    

    .process-wizard-step-label {
        padding-top: 3px;
        padding-left: 34px;
    }

    .process-wizard-step-label-active {
        font-weight: 700;
    }

    .process-wizard-step-details {
        width: 75%; 
        float: left; 
        padding: 20px;
        padding-bottom: 0;
        padding-right: 0;
    }

    .process-wizard-step-details h5 {
        margin-bottom: 20px;
    }    

    .process-wizard-step-step {
        min-height: 310px;
    }

    .process-wizard-footer {
        float: left;
        width: 100%;
    }

    .hideAction {
        display: none;
    }

    /* master nft structure */
    .nft-row {
        width: 100%;
        float: left;
    }

    .nft-master-image-container {
        float: left;    
    }

    .nft-master-label-container {
        float: left;
        margin-left: 15px;
        margin-top: 5px;        
    }

    .nft-sub-label {
        font-size: 11px;
        color: grey;        
    }

    .nft-child-link-container {
        position: relative;
        float: left;
    }

    .nft-child-link {
        float: left;
        position: absolute;
        width: 40px; 
        height: 35px; 
        border-left: 1px solid grey; 
        border-bottom: 1px solid grey; 
        top: 0; 
        left: 25px;
    }

    .nft-child-link-down {
        float: left;
        position: absolute;
        width: 40px; 
        height: 25px; 
        border-left: 1px solid grey; 
        top: 35px; 
        left: 25px;
    }    

    .nft-child-image-container {
        float: left;
        margin-left: 65px;
        margin-top: 10px;
    }

    .nft-child-label-container {
        float: left;
        margin-left: 15px;
        margin-top: 24px;        
    }

    .nft-not-selected {
        color: grey;
    }

    /* NFT cost data */
    .nft-cost-data-key {
        width: 90px;
    }

    .nft-cost-data-currency {
        /* padding-left: 20px; */
        padding-right: 0;
    }    

    .nft-cost-data-currency-value {
        width: 55px; 
        text-align: right;
        padding-left: 0;
    }

    .nft-cost-link {
        /* padding-left: 20px;
        padding-right: 20px; */
    } 
    
    .nft-cost-data-bottom-border {
        border-bottom: 1px solid #000;
    }

    .nft-cost-data-bottom-border-thick {
        border-bottom: 2px solid #000;
    }         

    .section-label {
        position: relative;
        /* padding-bottom: 16px; */
        /* height: 50px; */
        padding-top: 10px;
        border-top: 1px solid #e6ebf1;
        /* padding-left: 40px; */
    }

    .section-label-last {
        border-bottom: 1px solid #e6ebf1;
    }    

    .section-label-details {
        /* position: absolute; */
        /* top: 0;
        left: 30px; */
        padding-left: 40px;
        padding-bottom: 10px;
    }

    .section-icon {
        position: absolute;
        top: 12px;
        left: 0;
        font-size: 25px;
    }

    .section-chevron {
        position: absolute;
        right: 0;
        top: 0;
        padding-right: 15px;
        padding-top: 20px;
        font-size: 18px;
        margin-top: -3px;
    }

    .collapse-section-container:hover {
        cursor: default;
    }

    .collapse-section-container {
        padding-bottom: 15px;
        /* padding-left: 40px; */
    }    

    .section-hr {
        margin-top: 0px;
    }

    .section-label-last {
        /* border-bottom: none; */
    }

    .summary-section-table {
        /* margin-top: 10px; */
    }

    .financial-section-heading {
        padding-bottom: 10px;
    }


    .summary-data-container {
        float: left;
    }

    .pagination-table {
        /*display: flex;
        position: relative;
        float: right;
        right: 10px;
        min-width: 95%;
        justify-content: flex-end;*/
    }

    .table-search {
        display: flex;
        justify-content: flex-end;
        position: relative; float: right; min-width: 64%; margin-bottom: 15px;
    }
    .pagination-element {
        position: relative; float: right; min-width: 40%;
    }

    .humanSubItemsTable:table { max-width: 95%; display: flex; justify-content: center; }

    @media (max-width: 767px) {

        .pagination-table {
            float: left;
            padding-left: 10px;
            min-width: 100%;
        }

        .table-search {
            float: left;
            min-width: 100%;
            font-size: .5em;
            /*justify-content: space-between;*/
        }

        .summary-data-container {
            position: relative !important;
            float: right !important;
            top: -380px !important;
        }

        .nft-summary {
            padding-top: 15px;
            width: 100% !important;
        }
    }

    /* For small tablets (iPad mini, etc) */
    @media (max-width: 768px) {
        .nft-summary {
            padding-top: 15px;
            width: 100% !important;
        }
    }

    /* For MEdium tablets (iPad, etc) */
    @media (max-width: 820px) {
        .nft-summary {
            padding-top: 25px;
            width: 100% !important;
        }
    }

    /* For larger tablets (Surface Pro, etc) */
    @media (max-width: 912px) {
        .nft-summary {
            padding-top: 25px;
            width: 100% !important;
        }
    }

    .clickable {
        cursor: pointer
    }
</style> 

